<template>
    <div class="NewsCenterWarp">
        <div>
            <NavMenu/>
        </div>
        <div class="newtopBox">
            <div class="topleftBox" v-if="NoticeDataList.length!=0">
                <div class="firstInfobox" @click="goNewsDetailFn(NoticeDataList[0])">
                    <img class="imgbox" :src="srcUrl+NoticeDataList[0].titleImgUrl" />
                    <div class="headlineBox overflowone">{{NoticeDataList[0].pressTopic}}</div>
                </div>
                <div class="secondBox">
                    <div class="infobox" @click="goNewsDetailFn(NoticeDataList[1])">
                        <img class="imgbox" :src="srcUrl+NoticeDataList[1].titleImgUrl" />
                        <div class="headlineBox overflowone">{{NoticeDataList[1].pressTopic}}</div>
                    </div>
                    <div class="infobox secondinfobox" @click="goNewsDetailFn(NoticeDataList[2])">
                        <img class="imgbox" :src="srcUrl+NoticeDataList[2].titleImgUrl" />
                        <div class="headlineBox overflowone">{{NoticeDataList[2].pressTopic}}</div>
                    </div>
                </div>
            </div>
            <div class="informBox">
                <div class="commonTabTitleBox">
                    <span class="title">
                        <span class="line"></span>通知公告</span>
                    <span class="morebox" @click="gonewsecond1">
                        更多
                        <i class="el-icon-caret-right"></i>
                    </span>
                </div>
                <div class="inforDataBox">
                    <div class="inforItemBox" v-for="(item,index) in testDataList" :key="index" @click="goNewsDetailFn(item)">
                        <img class="imgbox" :src="srcUrl+item.titleImgUrl" />
                        <div class="msgbox">
                            <div class="headlineBox">{{item.pressTopic}}</div>
                            <div class="time">{{item.pressTime | timer}}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 时政要闻 -->
        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">时政要闻</span>
            <span class="right-line"></span>
        </div>
        <div class=" politicsNewsBox">
            <div class="rightMore" @click="gonewsecond2">
                <span class="morebox">
                    更多
                    <i class="el-icon-caret-right"></i>
                </span>
            </div>
            <div class="topTextBotImgBox" v-if="cacfoNewsData.length!==0">
                <div v-for="(item,index) in cacfoNewsData" :key="index" class="newsItembox" @click="goNewsDetailFn(item)">
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />

                </div>
            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />
            </div>

        </div>
        <!-- <div class="primaryTitle">
            <el-divider>
                <span class="title">协会动态</span>
            </el-divider>
        </div>
        <div class=" cacfoNewsBox">
            <div class="rightMore">
                <span class="morebox">
                    更多
                    <i class="el-icon-caret-right"></i>
                </span>
            </div>
            <div class="newsDataBox">
                <div v-for="(item,index) in testDataList" :key="index" class="newsItembox">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">行业动态</span>
            <span class="right-line"></span>
        </div>
        <div class="industryDynamicsBox">
            <div class="rightMore" @click="gonewsecond3">
                <span class="morebox">
                    更多
                    <i class="el-icon-caret-right"></i>
                </span>
            </div>
            <div class="leftImgRightTextBox" v-if="industryNewsData.length!==0">
                <div v-for="(item,index) in industryNewsData" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>

            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />
            </div>

        </div>

        <Footer/>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            testDataList: [],
            NoticeDataList: [],
            cacfoNewsData: [],
            industryNewsData: [],
        }
    },
    mounted() {
        this.getTest()
        this.getcacfoList()
        this.getindustryList()
    },
    methods: {
        async getTest() {
            let params = {
                pageSize: 6,
                pageCurrent: 1,
                pressSuperClass: "16",
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.testDataList = data.result.list.splice(3);
                this.NoticeDataList = data.result.list.splice(0, 3);
            }
        },
        async getcacfoList() {
            let params = {
                pageSize: 6,
                pageCurrent: 1,
                pressSuperClass: 22,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.cacfoNewsData = data.result.list
            }
        },
        async getindustryList() {
            let params = {
                pageSize: 6,
                pageCurrent: 1,
                pressSuperClass: 1,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.industryNewsData = data.result.list
            }
        },
        gonewsecond1() {
            this.$router.push('/news-secondpage/notice');
        },
        gonewsecond2() {
            this.$router.push('/news-secondpage/politics');
        },
        gonewsecond3() {
            this.$router.push('/news-secondpage/industry-dynamics');
        },
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.NewsCenterWarp {
	width: 100%;
	margin: 0 auto;
	.newtopBox {
		width: 1340px;
		margin: 40px auto 0 auto;
		display: flex;
		flex-direction: row;
		.topleftBox {
			display: flex;
			flex-direction: row;
			margin-right: 34px;
			.firstInfobox {
				width: 448px;
				height: 417px;
				position: relative;
				cursor: pointer;
				imgbox {
					width: 100%;
					height: 100%;
				}
				.headlineBox {
					width: 100%;
					position: absolute;
					background: rgba(0, 0, 0, 0.39);
					bottom: 0;
					padding: 10px 20px;
					line-height: 28px;
					color: #ffffff;
					font-size: 18px;
					font-weight: bold;
					box-sizing: border-box;
				}
			}
			.secondBox {
				display: flex;
				flex-direction: column;
				width: 304px;
				margin-left: 20px;
				.infobox {
					width: 304px;
					height: 200px;
					position: relative;
					cursor: pointer;
					img {
						width: 100%;
						height: 100%;
					}
					.headlineBox {
						width: 100%;
						position: absolute;
						background: rgba(0, 0, 0, 0.39);
						bottom: 0;
						padding: 10px 20px;
						line-height: 28px;
						color: #ffffff;
						font-size: 16px;
						font-weight: bold;
						box-sizing: border-box;
					}
				}
				.secondinfobox {
					margin-top: 18px;
				}
			}
		}
		.informBox {
			width: 520px;
			.inforDataBox {
				.inforItemBox {
					display: flex;
					flex-direction: row;
					margin-bottom: 28px;
					&:first-child {
						padding-top: 21px;
					}
					&:last-child {
						margin-bottom: 0;
					}
					.imgbox {
						width: 149px;
						height: 93px;
					}
					.msgbox {
						width: 68%;
						padding: 0 0 0 18px;
						text-align: left;
						.headlineBox {
							cursor: pointer;
							line-height: 28px;
							color: #666666;
							font-size: 16px;
							text-overflow: -o-ellipsis-lastline;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.time {
							line-height: 36px;
							color: #999999;
						}
					}
				}
			}
		}
	}
	.politicsNewsBox {
		width: 1340px;
		margin: 40px auto 0 auto;
	}
	.cacfoNewsBox {
		width: 1340px;
		margin: 40px auto 0 auto;
		.itemBox {
			cursor: pointer;
		}
	}
	.industryDynamicsBox {
		width: 1340px;
		margin: 40px auto 0 auto;
		.leftImgRightTextBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.itemBox {
				display: flex;
				flex-direction: row;
				margin: 0 90px 50px 0;
				width: 46.6%;
				cursor: pointer;
				img {
					width: 248px;
					height: 142px;
				}
				.contentbox {
					width: 60%;
					padding: 0 0 0 20px;
					box-sizing: border-box;
					.title {
						font-size: 18px;
						line-height: 36px;
						color: #333333;
					}
					.synopsis {
						font-size: 16px;
						line-height: 30px;
						color: #666666;
					}
					.time {
						margin-top: 10px;
						line-height: 36px;
						color: #999999;
					}
				}
				&:nth-child(2n) {
					margin-right: 0;
				}
			}
		}
	}
}
</style>


